/**
 * List of allowed countries where can be used GPC
 */
export const allowedCountriesWithGpc = ['US'];

/**
 * @name getGpcEnable
 * @description Returns value did a user enable gpc
 * @param {undefined | string} - A user location
 * @returns {boolean}
 */
export const getGpcEnable = userLocation => {
  var _navigator;
  return !!((_navigator = navigator) !== null && _navigator !== void 0 && _navigator.globalPrivacyControl) && !!userLocation && allowedCountriesWithGpc.includes(userLocation);
};